import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Navbar from "./Navbar_old";
import profileImg from "../component/images/profile.jpg";

const API = "https://rishtey.rishteymatch.in/api2";

const RegisterAndDetail = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [userId, setUserId] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  const [formData, setFormData] = useState({
    full_name: "",
    username: "",
    email: "",
    password: "",
    mobile: "",
    age: "",
    dob: "",
    gender: "",
    marital_status: "",
    country: "",
    user_state: "",
    city: "",
    pincode: "",

    education: "",
    education_detail: "",
    profession: "",
    occupation: "",
    occupation_detail: "",
    income: "",

    height: "",
    weight: "",
    color: "",
    diet: "",
    disability: "",
    blood_group: "",
    profile_created_by: "",

    gotra: "",
    subcaste: "",
    mother_tongue: "",
    tob: "",
    pob: "",
    zodiac: "",
    manglik: "",
    nakshatra: "",

    whatsapp: "",
    father_contact: "",
    email_contact: "",
    town: "",
    present_address: "",
    permanent_address: "",

    father_name: "",
    father_occupation: "",
    mother_name: "",
    mother_occupation: "",
    married_brothers: "",
    unmarried_brothers: "",
    married_sisters: "",
    unmarried_sisters: "",
    maternal_uncle_name: "",
    maternal_uncle_gotra: "",
    house: "",
    car: "",

    image: null,
  });


  // ---------------- AGE FROM DOB ----------------
  const calculateAge = (dob) => {
    if (!dob) return "";
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) age--;
    return age;
  };

  const handleChange = (field, value) =>
    setFormData((prev) => ({ ...prev, [field]: value }));

  // ---------------- IMAGE ----------------
  const handleImageChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  // ❌ No size restriction
  // ❌ No type restriction

  setFormData((prev) => ({ ...prev, image: file }));

  // Preview (even for large images)
  const reader = new FileReader();
  reader.onloadend = () => {
    setImagePreview(reader.result);
  };
  reader.readAsDataURL(file);
};

  // ---------------- SAVE ----------------
  const saveToDatabase = async () => {
    const form = new FormData();
    Object.keys(formData).forEach((key) => {
      if (formData[key]) form.append(key, formData[key]);
    });
    if (userId) form.append("id", userId);

    const res = await fetch(`${API}/register-step`, {
      method: "POST",
      body: form,
    });
    const data = await res.json();
    if (data.success && data.id) setUserId(data.id);
  };


  const handleBack = () => setStep(step - 1);
  const progress = Math.round((step / 4) * 100);

  // ---------------- STEPS ----------------
  const stepFields = {
    1: [
      "full_name",
      // "username",
      "email",
      "password",
      "mobile",
      "gender",
      "marital_status",
      "dob",
      "country",
      "user_state",
      "city",
    ],
    2: [
      "education",
      "education_detail",
      "profession",
      "occupation",
      "occupation_detail",
      "income",
    ],
    3: [
    
      "height",
      "weight",
      "color",
      "diet",
      "disability",
      "blood_group",
      "profile_created_by",
      "gotra",
      "subcaste",
      "mother_tongue",
      "tob",
      "pob",
      "zodiac",
      "manglik",
      "nakshatra",
      "whatsapp",
      "father_contact",
      "email_contact",
      "town",
      "pincode",
      "present_address",
      "permanent_address",
    ],
    4: [
      "father_name",
      "father_occupation",
      "mother_name",
      "mother_occupation",
      "married_brothers",
      "unmarried_brothers",
      "married_sisters",
      "unmarried_sisters",
      "maternal_uncle_name",
      "maternal_uncle_gotra",
      "house",
      "car",
    ],
  };

  // ---------------- RENDER ----------------
  const renderFields = (fields) =>
    fields.map((f) => {
      const selectOptions = {
        gender: ["Male", "Female", "Other"],
        marital_status: ["Single", "Married", "Divorced", "Widowed"],
        country: ["India"],
        diet: ["Veg", "Non-Veg", "Jain"],
        disability: ["No", "Yes"],
        blood_group: ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"],
        manglik: ["Yes", "No"],
        profile_created_by: ["Self", "Parents", "Relative"],
        house: ["Yes", "No"],
        car: ["Yes", "No"],
      };

      return (
        <div className="col-md-6 mb-3" key={f}>
          <label className="form-label text-capitalize">
            {f.replace(/_/g, " ")}
          </label>

          {selectOptions[f] ? (
            <select
              className="form-control"
              value={formData[f]}
              onChange={(e) => handleChange(f, e.target.value)}
            >
              <option value="">Select</option>
              {selectOptions[f].map((o) => (
                <option key={o}>{o}</option>
              ))}
            </select>

          ) : f === "dob" ? (
            <input
              type="date"
              className="form-control"
              value={formData.dob}
              onChange={(e) => {
                handleChange("dob", e.target.value);
                handleChange("age", calculateAge(e.target.value));
              }}
            />

          ) : ["mobile", "whatsapp", "father_contact"].includes(f) ? (
            <input
              className="form-control"
              value={formData[f]}
              maxLength={10}
              onChange={(e) => {
                const v = e.target.value.replace(/\D/g, "");
                if (v.length <= 10) handleChange(f, v);
              }}
              placeholder="10 digit number"
            />

          ) : f === "password" ? (
            <input
              type="password"
              className="form-control"
              value={formData[f]}
              onChange={(e) => handleChange(f, e.target.value)}
            />

          ) : (
            <input
              className="form-control"
              value={formData[f]}
              onChange={(e) => handleChange(f, e.target.value)}
            />
          )}
        </div>
      );
    });

    const handleSkip = () => {
  alert(`⏭️ Step ${step} skipped`);

  if (step < 4) {
    setStep(step + 1);
  } else {
    navigate("/login");
  }
};

const handleNext = async (e) => {
  e.preventDefault();

  if (!validateStep()) return; // ⛔ agar step incomplete

  await saveToDatabase();

  alert(`✅ Step ${step} completed successfully`);

  if (step < 4) {
    setStep(step + 1);
  } else {
    alert("🎉 Registration Completed Successfully!");
    navigate("/login");
  }
};



const requiredFieldsByStep = {
  1: ["full_name", "email", "password", "mobile", "gender", "dob"],
  2: ["education", "profession", "occupation"],
  3: ["height", "diet", "blood_group"],
  4: ["father_name", "mother_name"]
};

const validateStep = () => {
  const requiredFields = requiredFieldsByStep[step] || [];

  for (let field of requiredFields) {
    if (!formData[field] || formData[field].toString().trim() === "") {
      alert(`❌ Please fill ${field.replace(/_/g, " ")}`);
      return false;
    }
  }

  return true;
};

  return (
    <>
      <Navbar />

      <div className="container py-4 mb-5">
        <div className="progress mb-4 d-none">
          <div className="progress-bar bg-success" style={{ width: `${progress}%` }}>
            {progress}%
          </div>
        </div>

        <div className="bg-dark text-light p-4 rounded">
          {/* IMAGE */}
          <div className="text-center mb-4">
            <input
              type="file"
              id="imageUpload"
              accept="image/*"
              hidden
              onChange={handleImageChange}
            />
            <label htmlFor="imageUpload">
              <img
                src={imagePreview || profileImg}
                alt="profile"
                className="rounded-circle"
                style={{ width: 90, height: 90, objectFit: "cover", cursor: "pointer" }}
              />
            </label>
            <div>Upload Photo</div>
          </div>

          <form onSubmit={handleNext}>
            <div className="row">{renderFields(stepFields[step])}</div>

          <div className="d-flex justify-content-between mt-3">
  {step > 1 ? (
    <button
      type="button"
      className="btn btn-secondary"
      onClick={handleBack}
    >
      ← Back
    </button>
  ) : <div />}

  <div className="d-flex gap-2">
    <button
      type="button"
      className="btn btn-outline-warning"
      onClick={handleSkip}
    >
      Skip →
    </button>

    <button type="submit" className="btn btn-success">
      {step === 4 ? "Finish ✔" : "Next →"}
    </button>
  </div>
</div>

          </form>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default RegisterAndDetail;
